import { gql } from '@apollo/client';

export const GET_USERS = gql`
  query getUsers($filterQuery: String!) {
    getUsers(filterQuery: $filterQuery)
      @rest(type: "users", path: "admin/?query={args.filterQuery}") {
      nextPage
      data {
        id
        email
        fullName
        lastUpdated
        company
        profilePicture
      }
    }
  }
`;
